import { propertyType, t } from '@blocksuite/data-view';
import zod from 'zod';

import {
  RELATION_PROPERTY_TYPE,
  RelationPropertySchema,
  RelationRawValueSchema,
} from './types.js';

export const relationPropertyType = propertyType(RELATION_PROPERTY_TYPE);

export const relationPropertyModelConfig = relationPropertyType.modelConfig({
  name: 'Relation',
  propertyData: {
    schema: RelationPropertySchema,
    default: () =>
      ({
        _v: 1,
        targetDocId: null,
        targetBlockId: null,
        pairedColumnId: null,
      }) as const,
  },
  jsonValue: {
    schema: RelationRawValueSchema,
    isEmpty: ({ value }) => !value || value.length === 0,
    type: () => t.unknown.instance(),
  },
  rawValue: {
    schema: RelationRawValueSchema,
    default: () => [],
    toString: ({ value }) =>
      (value ?? []).map(r => `${r.docId}/${r.blockId}`).join(','),
    fromString: () => ({ value: [] }),
    toJson: ({ value }) => value ?? [],
    fromJson: ({ value }) => {
      const parsed = zod.array(zod.unknown()).safeParse(value);
      if (!parsed.success) return [];
      const refs: { _v: 1; docId: string; blockId: string }[] = [];
      for (const item of parsed.data) {
        if (
          typeof item === 'object' &&
          item !== null &&
          'docId' in item &&
          'blockId' in item &&
          typeof (item as { docId: unknown }).docId === 'string' &&
          typeof (item as { blockId: unknown }).blockId === 'string'
        ) {
          refs.push({
            _v: 1,
            docId: (item as { docId: string }).docId,
            blockId: (item as { blockId: string }).blockId,
          });
        }
      }
      return refs;
    },
  },
});
